import { createTheme } from "@mui/material/styles";

// Tokens
export const BUTTON_RADIUS = 4;
export const DIALOG_RADIUS = 3;

// Base MUI theme used across vendor modals/buttons
export const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#536DEC",
      contrastText: "#ffffff",
    },
  },
  shape: { borderRadius: DIALOG_RADIUS },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: `${BUTTON_RADIUS}px !important`,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: DIALOG_RADIUS,
        },
      },
    },
  },
});

export default muiTheme;

